// store/modules/auth.js

const state = {
  user: null,
  email: null,
  setting: null,
  code: null,
  ids: [],
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_SETTINGS(state, setting) {
    state.setting = setting;
  },
  SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_CODE(state, code) {
    state.code = code;
  },
  SET_IDS(state, ids) {
    state.ids = ids;
  }
};

const actions = {
  setUser({ commit }, user) {
    commit('SET_USER', user);
  }, 
  setSettings({ commit }, setting) {
    commit('SET_SETTINGS', setting);
  },
  setEmail({ commit }, email) {
    commit('SET_EMAIL', email);
  },
  setCode({ commit }, code) {
    commit('SET_CODE', code);
  },
  setIds({ commit }, ids) {
    commit('SET_IDS', ids);
  }
};

const getters = {
  getUser: (state) => state.user,
  getSetting: (state) => state.setting,
  getEmail: (state) => state.email,
  getCode: (state) => state.code,
  getIds: (state) => state.ids,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
